"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getIntegerFromUnknown_1 = __importDefault(require("../../shared/getIntegerFromUnknown"));
const buildCallableSetAudioTime = (args) => async ({ entryVars: { timeSeconds: timeSecondsEntry, }, processor, }) => {
    const onError = (error) => {
        processor.root.alert('Error when pausing audio', `${error}`);
    };
    try {
        const timeSeconds = (0, getIntegerFromUnknown_1.default)(timeSecondsEntry);
        await args.setAudioTime(timeSeconds);
    }
    catch (error) {
        onError(error);
    }
};
exports.default = buildCallableSetAudioTime;
